import { IconArrowsMaximize } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Deal } from '../../types';
import { type DealCoordinates } from '../../dealsMapGeoJson';
import { useDealsMapboxMap } from '../hooks/useDealsMapboxMap';
import { DealColorLookup } from '../hooks/useColoredDealIds';
import './DealsMap.scss';

interface IDealsMapProps {
    deals: Deal[];
    geocodedCoordinates: Record<number, DealCoordinates>;
    selectedDealId: number | null;
    hoveredDealId: number | null;
    colorByDealId?: DealColorLookup;
    onSelectDeal: (deal: Deal) => void;
    onDeselectDeal: () => void;
    onHoverDeal: (dealId: number | null) => void;
}

const DealsMap = ({
    deals,
    geocodedCoordinates,
    selectedDealId,
    hoveredDealId,
    colorByDealId,
    onSelectDeal,
    onDeselectDeal,
    onHoverDeal,
}: IDealsMapProps) => {
    const { containerRef, handleFitAll } = useDealsMapboxMap({
        deals,
        geocodedCoordinates,
        selectedDealId,
        hoveredDealId,
        colorByDealId,
        onSelectDeal,
        onDeselectDeal,
        onHoverDeal,
    });

    return (
        <div className="DealsMap">
            <div ref={containerRef} className="DealsMap__container" />
            <button
                type="button"
                className="DealsMap__fit-all-btn"
                onClick={handleFitAll}
                title="Show all deals"
                aria-label="Show all deals"
            >
                <NSIcon icon={IconArrowsMaximize} />
            </button>
        </div>
    );
};

export default DealsMap;
